@if (pbbWidgetData() && pbbWidgetData()?.length) {
    <accordion
        class="multiples-accordion"
        [ngClass]="{ 'carousel-header-layout': !isDesktop, 'homepage-accordion': isV2Design }"
        [isExpanded]="expanded"
        [accordionTitle]="pbbCmsData()?.data?.[0]?.moduleTitle"
        [card]="true"
        (function)="manageAccordionClick($event)"
        [accordionSvg]="accordionSvg"
        data-crlat="pbb-acc">
        @if (expanded) {
            <accordion-body>
                <div
                    [ngClass]="{
                        'carousel-half-slides': pbbWidgetData()?.length === 2 && !pbbWidget,
                        'fit-slides': isFit,
                        'homepage-rcc-v2design': isV2Design,
                    }"
                    (mouseover)="isHovered = true"
                    (mouseleave)="isHovered = false"
                    [entryAccessor]="sizeAccessor"
                    (vnObserveSize)="carouselWidth.set($event.width)"
                    class="pbb-carousel pbb-carousel-padding"
                    data-crlat="pbbBetsCarousel"
                    scrollonce
                    [elemEventType]="'touchmove'"
                    [scrollonce]="'PbbWidget'">
                    <div
                        class="ng-carousel pbb-carousel main-container"
                        [ngCarousel]
                        [ngClass]="{ 'main-layout': !isDesktop, 'homepage-byb-v2design': isV2Design }"
                        (slidedSide)="fetchPbbWidgetCarouselData($event)"
                        [ngCarouselWatch]="pbbWidgetData()?.length"
                        [ngCarouselName]="PbbCarousel"
                        [ngCarouselFluid]="true"
                        [ngCarouselLoop]="false"
                        data-crlat="pbb-carousel"
                        [ngCarouselMoveThresholdPercentage]="5">
                        <slidecontainer
                            class="carousel-slides carousel-slides-mobile"
                            [ngClass]="{ 'carousel-no-scroll': pbbWidgetData()?.length === 1 }">
                            @for (eventEntity of pbbWidgetData(); track $index; let eventIndex = $index) {
                                <slide
                                    #slide
                                    class="slide slide-all-events"
                                    [entryAccessor]="sizeAccessor"
                                    (vnObserveSize)="eventIndex === 0 && slideWidth.set($event.width)"
                                    data-crlat="pbb-slide">
                                    <div class="content-body" data-crlat="pbb-content-body">
                                        <div class="content-section" data-crlat="pbb-content-section">
                                            <header
                                                class="pbb-header"
                                                [entryAccessor]="sizeAccessor"
                                                (vnObserveSize)="eventIndex === 0 && pbbHeaderHeight.set($event.height)"
                                                data-crlat="pbbWidgetHeader"
                                                (click)="goToMrktOrEdp(eventEntity, eventIndex)">
                                                <div class="text-area" data-crlat="pbb-full-event-name">
                                                    <span [textContent]="removePipes(eventEntity?.events?.[0]?.name)"> </span>
                                                </div>
                                                <div data-crlat="pbb-event-start-time" class="sub-head-container">
                                                    <span class="sub-head-time" [textContent]="getEventName(eventEntity)"> </span>
                                                </div>
                                            </header>
                                            <section data-crlat="pbb-eventGroup" #sectionPbb class="section-pbb">
                                                <ul class="event-Data-layout">
                                                    @for (market of eventEntity?.events?.[0]?.markets; track $index; let outcomeIndex = $index) {
                                                        <li
                                                            data-crlat="pbb-eventGroup"
                                                            [ngClass]="{ 'li-round-container': isDesktop }"
                                                            class="event-container"
                                                            data-crlat="popular-accas-card-event-container"
                                                            [entryAccessor]="sizeAccessor"
                                                            (vnObserveSize)="
                                                                eventIndex === 0 && outcomeIndex === 0 && oddsCardHeight.set($event.height)
                                                            "
                                                            class="odds-card pbb-card card-main"
                                                            data-crlat="bybWidgetCard.odds">
                                                            <div class="card-container">
                                                                <div class="event-details-layout">
                                                                    <div
                                                                        class="card-template template-layout"
                                                                        data-crlat="pbb-card-main"
                                                                        [textContent]="market?.outcomes?.[0]?.name"></div>
                                                                    <div
                                                                        class="market-container template-layout"
                                                                        data-crlat="pbb-card-market-name"
                                                                        [textContent]="market?.name"></div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    }
                                                </ul>
                                            </section>
                                        </div>
                                        <div data-crlat="bb-card-add-to-betslip" data-crlat="pbb-add-betslip">
                                            @if (eventRef[eventIndex]) {
                                                <pre-created-add-to-betslip
                                                    [hashIdSignal]="eventEntity?.hashId"
                                                    [priceSignal]="eventEntity?.aggregatedPrice"
                                                    [eventRefSignal]="eventRef[eventIndex]"
                                                    [eventIndex]="eventIndex"
                                                    [markets]="eventEntity?.events?.[0]?.markets"
                                                    [initiator]="featuredModule">
                                                </pre-created-add-to-betslip>
                                            }
                                        </div>
                                    </div>
                                </slide>
                            }
                        </slidecontainer>
                    </div>
                    @if (isDesktop) {
                        <div class="pbb-carousel-buttons">
                            <button
                                class="pbb-arrow prev-race"
                                (click)="prevSlide()"
                                [ngClass]="{ 'pbb-arrow-hide': !showPrev }"
                                data-crlat="arrow-prev">
                                <svg>
                                    <use xlink:href="#prev-arrow"></use>
                                </svg>
                                <span [i18n]="'sb.previousCard'" data-crlat="pre-arrow"></span>
                            </button>
                            <button
                                class="pbb-arrow next-race"
                                (click)="nextSlide()"
                                [ngClass]="{ 'pbb-arrow-hide': !showNext }"
                                data-crlat="arrow-next">
                                <span [i18n]="'sb.nextCard'" data-crlat="next-arrow"></span>
                                <svg>
                                    <use xlink:href="#next-arrow"></use>
                                </svg>
                            </button>
                        </div>
                    }
                </div>
            </accordion-body>
        }
    </accordion>
}
